import apiHandler from './apiHandler';

const { publicRequest, tenantRequest } = apiHandler;

function getAllInverters({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/inverters/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAlarms({
  signal,
  start_date,
  end_date,
  license_plate,
  search,
  severity,
  offset,
  limit,
}) {

  const params = {
    start_date, end_date, license_plate, search, severity, offset, limit,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  return tenantRequest(`/alarms/?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function getAlarmsRules({
  name__in, offset, limit, search, signal,
} = {}) {

  const params = {
    name__in, search, offset, limit,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  return tenantRequest(`/device-events/inverter-event-notifications/?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function createAlarmRule({ signal, body } = {}) {

  return tenantRequest('/alarms/rules', {

    method: 'POST',
    reqAuth: true,
    body,
    signal,
  });

}

function updateAlarm({ signal, id, body } = {}) {

  return tenantRequest(`/alarms/rules/${id}`, {
    method: 'PATCH',
    reqAuth: true,
    body,
    signal,
  });

}

function createUpdateAlarm({ id, body, signal } = {}) {

  const endpoint = id ? `/device-events/inverter-event-notifications/${id}` : '/device-events/inverter-event-notifications/';
  const method = id ? 'PATCH' : 'POST';
  return tenantRequest(endpoint, {
    reqAuth: true,
    method,
    body,
    signal,
  });

}

function getAlarmById({ id, signal } = {}) {

  const method = 'GET';
  return tenantRequest(`/device-events/inverter-event-notifications/${id}`, {
    reqAuth: true,
    method,
    signal,
  });

}

function deleteAlarmById({ id, signal } = {}) {

  return tenantRequest(`/device-events/inverter-event-notifications/${id}`, {
    reqAuth: true,
    method: 'DELETE',
    signal,
  });

}

function deleteInverterById({ id, signal } = {}) {

  return tenantRequest(`/devices/inverters/${id}`, {
    reqAuth: true,
    method: 'DELETE',
    signal,
  });

}

function partialUpdateAlarm({ id, body, signal } = {}) {

  return tenantRequest(`/device-events/inverter-event-notifications/${id}/activate`, {
    reqAuth: true,
    method: 'POST',
    body,
    signal,
  });

}

function createInverter({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/inverters/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function editInverter({ signal, body, id }) {

  console.log('editInverter', body);
  const method = 'PATCH';
  return publicRequest(`/devices/inverters/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

export default {
  getAlarms,
  getAlarmsRules,
  createAlarmRule,
  updateAlarm,
  getAlarmById,
  createUpdateAlarm,
  deleteAlarmById,
  partialUpdateAlarm,
  getAllInverters,
  createInverter,
  deleteInverterById,
  editInverter,
};
